export function createMarkerContainer(size = 28) {
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.width = `${size}px`;
  container.style.height = `${size}px`;
  container.style.transform = 'translate(-50%, -50%)';
  container.style.display = 'flex';
  container.style.alignItems = 'center';
  container.style.justifyContent = 'center';
  container.style.cursor = 'pointer';
  container.style.overflow = 'visible';
  return container;
}

export function createMarkerImg(src: string, alt: string, size = 28) {
  const img = document.createElement('img');
  img.src = src;
  img.alt = alt;
  img.width = size;
  img.height = size;
  img.draggable = false;
  img.style.display = 'block';
  return img;
}

export function createLinkBadge(ptwNo: string | null | undefined, linkIconSrc: string) {
  if (!ptwNo) return null;

  const badge = document.createElement('img');
  badge.src = linkIconSrc;
  badge.alt = 'link';
  badge.width = 16;
  badge.height = 16;
  badge.draggable = false;
  badge.style.position = 'absolute';
  badge.style.right = '2px';
  badge.style.top = '2px';
  badge.style.pointerEvents = 'none';
  return badge;
}

export type TooltipRow = { label: string; value: string | number };

export function createTooltip() {
  const el = document.createElement('div');
  el.style.position = 'absolute';
  el.style.backgroundColor = 'rgba(30,30,30,0.88)';
  el.style.color = '#ffffff';
  el.style.padding = '12px 16px';
  el.style.borderRadius = '8px';
  el.style.fontSize = '13px';
  el.style.lineHeight = '1.6';
  el.style.maxWidth = '280px';
  el.style.pointerEvents = 'none';
  el.style.zIndex = '9999';
  el.style.display = 'none';
  el.style.transform = 'translate(-50%, -120%)';
  return el;
}

export function showTooltip(
  tooltip: HTMLDivElement,
  rows: TooltipRow[],
  x: number,
  y: number
) {

  tooltip.innerHTML = rows
    .map(
      (r) =>
        `<div style="display:flex;justify-content:space-between;gap:16px">` +
        `<span style="color:rgba(255,255,255,0.7);flex-shrink:0">${r.label}</span>` +
        `<span style="font-weight:600;color:#ffffff;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${r.value || '-'}</span>` +
        `</div>`
    )
    .join('');
  tooltip.style.left = `${x}px`;
  tooltip.style.top = `${y}px`;
  tooltip.style.display = 'block';
}

export function hideTooltip(tooltip: HTMLDivElement) {
  tooltip.style.display = 'none';
}
